
                                module.exports = new Proxy({}, {
                                    get: function() {
                                        console.warn('[TOOLBAR] Attempted to use denied module:', "lib/monaco/CodeEditor");
                                        return function() { 
                                            console.warn('[TOOLBAR] Called denied module:', "lib/monaco/CodeEditor");
                                            return {} 
                                        }
                                    }
                                });
                            